import React from 'react';

import { TAB } from '../CycleDetailPage';

import StagesTabSection from '../StagesTabSection/StagesTabSection';
import OverviewTabSection from '../OverviewTabSection/OverviewTabSection';

const CycleTabsContent = ({ activeTab, cycleDetail, setCycleDetail, orgMembersHookResponse }) => {
    const overviewTabClassName = activeTab === TAB.overview ? 'block' : 'hidden';
    const stagesTabClassName = activeTab === TAB.stages ? 'block' : 'hidden';

    return (
        <>
            <div className={overviewTabClassName}>
                <OverviewTabSection
                    cycleDetail={cycleDetail}
                    setCycleDetail={setCycleDetail}
                    orgMembersHookResponse={orgMembersHookResponse}
                />
            </div>

            <div className={stagesTabClassName}>
                <StagesTabSection cycleDetail={cycleDetail} setCycleDetail={setCycleDetail} />
            </div>
        </>
    );
};

export default CycleTabsContent;
